import HeaderTitle from 'Components/HeaderTitle/HeaderTitle';
import { Content } from 'Constants/styles';
import { LpBox } from 'Constants/styles';

import ManageDisputes from './ManageDisputes';

const Disputes = () => {
  return (
    <div className="mb-4">
      <HeaderTitle title="Disputes" />
      <Content>
        <LpBox>
          <ManageDisputes />
        </LpBox>
      </Content>
    </div>
  );
};

export default Disputes;
